import { useCallback, useState } from "react";
import { Breadcrumb, Button, Card, Input, Tabs } from "antd";
import { useNavigate } from "react-router";
import OwnAccountList from "../send-money/own-account-list";
import { ReactComponent as TitleIcon } from "../../assests/images/managebreadben.svg";
import AccountCard from "../../components/account-card";
import { useTranslation } from "react-i18next";
import { BiSearch } from "react-icons/bi";
import PesaLinkList from "./pesalink-beneficiary-list";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function PesaLinkBeneficiaryManagement() {
  const [activeKey, setActiveKey] = useState("PESALINK");
  const navigate = useNavigate();
  const [beneficiaryManagement, setBeneficiaryManagement] = useState(false);
  const { t } = useTranslation();
  const [searchField, setSearchField] = useState("");

  const handleChange = useCallback((value) => {
    setActiveKey(value);
    setSearchField("");
  }, []);

  const handleTabChange = (key) => {
    setSearchField("");
  };

  return (
    <>
      <Breadcrumb separator=">">
        {/* <Breadcrumb.Item>
          <span onClick={() => navigate("/dashboard")}>
            <HomeIcon height={14} />
          </span>
        </Breadcrumb.Item> */}
        <Breadcrumb.Item>
          <span onClick={() => navigate("/pesaLink")}>
            {t("navigation.pesaLink", {
              defaultValue: "Pesalink",
            })}
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span>
            {" "}
            {t("pages.Add_Bene.manage_beneficiaries", {
              defaultValue: "Manage Beneficiaries",
            })}
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {" "}
              {t("pages.Add_Bene.manage_beneficiaries", {
                defaultValue: "Manage Beneficiaries",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
          <Card className="application-card">
            <AccountCard />
          </Card>
        </div>

        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="account-tab-card mb-1">
            <div className="row d-flex mt-2">
              {" "}
              <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                <Tabs
                  defaultActiveKey="PESALINK"
                  type="line"
                  onChange={handleChange}
                  activeKey={activeKey}
                  style={{ marginTop: "10px", width: "100%" }}
                >
                  <Tabs.TabPane
                    tab={t("navigation.pesaLink", {
                      defaultValue: "Pesalink",
                    })}
                    key="PESALINK"
                  ></Tabs.TabPane>
                </Tabs>
              </div>
              <div className="style-xs col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Input
                  className="location-search-txt"
                  value={searchField}
                  placeholder={t(
                    "pages.beneficiaryManagement.common_beneficiaryManagement.search_by_nick",
                    { defaultValue: "Search By Nickname" }
                  )}
                  size="large"
                  suffix={<BiSearch style={{ fontSize: 14 }} />}
                  onChange={(e) => setSearchField(e.target.value)}
                />
              </div>
            </div>
          </Card>
          <Card className="send-money-card">
            {activeKey === "PESALINK" && (
              <>
                {" "}
                <PesaLinkList
                  beneficiaryManagement={beneficiaryManagement}
                  searchField={searchField}
                />
              </>
            )}
          </Card>
        </div>
      </div>
    </>
  );
}
